import Feature from "ol/Feature";
import Style from "ol/style/Style";
import Stroke from "ol/style/Stroke";
import Fill from "ol/style/Fill";

import { Polygon } from "ol/geom";
import { buffer } from "@turf/turf";
import { ConvertGeometryToGeoJson, GetSource } from "../map/mapUtil";

// Show the 10nm range bound volume for testing.
const SHOW_RANGE_BOUND_VOLUME = false;

export function AddRangeBoundVolume(map, asset) {
    if (!SHOW_RANGE_BOUND_VOLUME) {
        return;
    }

    const geoJson = ConvertGeometryToGeoJson(asset.getGeometry());
    const buffered = buffer(geoJson, 10 * 1852, { units: "meters" });
    const rangeBound = new Feature(new Polygon(buffered.geometry.coordinates));
    rangeBound.setId(`${asset.getId()}-monitor-test`);
    rangeBound.setStyle(
        new Style({
            stroke: new Stroke({
                color: "black",
                width: 2,
                lineDash: [10, 10]
            }),
            fill: new Fill({
                color: "rgba(0, 0, 0, 0.1)"
            })
        })
    );

    const assetMonitorSource = GetSource(map, "assetMonitors");
    assetMonitorSource.addFeature(rangeBound);
}

export function RemoveRangeBoundVolume(map, assetUUID) {
    if (!SHOW_RANGE_BOUND_VOLUME) {
        return;
    }

    const assetMonitorSource = GetSource(map, "assetMonitors");
    const rangeBound = assetMonitorSource.getFeatureById(`${assetUUID}-monitor-test`);
    if (rangeBound) {
        assetMonitorSource.removeFeature(rangeBound);
    }
}
